module.exports = "<wow-express-delivery-alert ng-if=\"$ctrl.isExpressClosed\">\r\n</wow-express-delivery-alert>\r\n\r\n<div class=\"timeslotAlert\"\r\n    ng-if=\"!$ctrl.isExpressClosed\" ng-show=\"$ctrl.alertMessage\" role=\"alert\">\r\n    <h4 class=\"timeslotAlert-heading\">\r\n        {{ ::$ctrl.settings.deliveryWindowAlerts.alertTitle }}\r\n    </h4>\r\n\r\n    <p>{{ $ctrl.alertMessage }}</p>\r\n\r\n    <button class=\"linkButton\" ng-click=\"$ctrl.hideAlert()\">\r\n        OK, I understand<span class=\"sr-only\">, close message</span>\r\n    </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/fulfilment/timeslots/timeslot-alert.component.html
// module id = 606
// module chunks = 0